import { render, staticRenderFns } from "./ManagementContract.vue?vue&type=template&id=384f9dcf&"
import script from "./ManagementContract.vue?vue&type=script&lang=js&"
export * from "./ManagementContract.vue?vue&type=script&lang=js&"
import style0 from "./ManagementContract.vue?vue&type=style&index=0&id=384f9dcf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports